import Vue from 'vue';
import BaseRepository from './BaseRepository';
import { getViewData } from '../modules/view-data';

class WhitelabelRepository extends BaseRepository {
    /**
     * Update a whitelabel instance
     * @param instance - instance id
     * @param data
     */
    update(instance, data) {
        return Vue.http.patch(getViewData('CLIENT_API_URL_BASE') + this.route('whitelabel.update', { instance }), data);
    }

    /**
     * Remove a space from whitelabel instance
     * @param instance - instance id
     * @param space - space id
     */
    deleteSpace(instance, space) {
        return Vue.http.delete(getViewData('CLIENT_API_URL_BASE') + this.route('whitelabel.deleteSpace', { instance, space }));
    }

}

export default new WhitelabelRepository;
